import React, { useState } from 'react';

import { ThemeProvider } from '@alphonsocode/kallos';
import AsyncSelect from 'react-select/async';
import { SingleSelectDW } from './style';

export interface Option {
  value: string;
  label: string;
}
const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    borderColor: state.isFocused ? '#006e7d' : '#c3ccd4',
    boxShadow: state.isFocused ? '0 0 0 1.5px #006e7d' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#006e7d' : '#c3ccd4',
    },
  }),
  option: (base: any) => ({
    ...base,
    textAlign: 'left',
    fontWeight: 560,
  }),
  singleValue: (base: any) => ({
    ...base,
    textAlign: 'left',
    width: '100%',
  }),
  input: (base: any) => ({
    ...base,
    textAlign: 'left',
  }),
  placeholder: (base: any) => ({
    ...base,
    textAlign: 'left',
  }),
  menu: (base: any) => ({
    ...base,
    textAlign: 'left',
  }),
};
function MultiSelectDropdown({
  placeholder,
  value,
  loadOptions,
  onChange,
  defaultOptions,
  disabled,
  isLoading,
  setIsOpen,
}) {
  return (
    <SingleSelectDW>
      <AsyncSelect<Option, true>
        defaultOptions={defaultOptions.slice(0, 50)}
        value={value}
        loadOptions={loadOptions}
        onChange={onChange}
        isSearchable
        isMulti
        placeholder={placeholder}
        loadingMessage={() => 'Searching...'}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? `No Options` : 'No Options'
        }
        styles={customStyles}
        isDisabled={disabled}
        isLoading={isLoading}
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => setIsOpen(false)}
        closeMenuOnSelect={false}
      />
    </SingleSelectDW>
  );
}

export default MultiSelectDropdown;
